import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-adyen-cvv',
    templateUrl: './modal-for-adyen-cvv.shared.component.html',
    styleUrls: ['./modal-for-adyen-cvv.shared.component.scss']
})
export class ModalForAdyenCVVComponent extends ModalViewComponent implements OnInit {
    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'sm';
    }

    public handleOnFormInit($event: FormGroup): void {
        this.handleHeightUpdate();
    }

    public handleOnFormSubmit(): void {
        this.close();
    }
}
